import { useQuery } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { BANK_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useBankBeneficialOwners(bankId: string, dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();

  const { data: beneficialOwners = [], isLoading: isLoadingBeneficialOwners } = useQuery({
    enabled: !!bankId && !!dispensaryId,
    queryKey: [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
    queryFn: () => beneficialOwnerApi.getBankBeneficialOwners(bankId, dispensaryId),
    meta: {
      snackbarErrorMessage: 'There was an issue loading beneficial owners.'
    }
  });

  return { beneficialOwners, isLoadingBeneficialOwners };
}
